export default __webpack_public_path__ + "static/flowers-f5712616a9c7a6354159bf510c93f5d8.svg";